export const TabsNavigationEnum = {
    PROFILE : 'profile' ,
    SHOPPING_CART : 'shopping_cart' ,
    PANEL : 'panel' ,
    STORE : 'store' ,
    ORDER : 'order' ,
}